<div class="app-container">
  <page-header [icon]="'far-money-check'" [title]="'coupons'">
    <ng-container class="header-button">
      <btn
        [routerLink]="['/voucher']"
        [icon]="'far-plus'"
        [label]="'coupon.create'"
        [classes]="['btn-first', 'float-right']"
        [dataCyAttribute]="'add-voucher'"
      ></btn>
      <app-exports #exportsModal [entity]="'vouchers'"></app-exports>
    </ng-container>
  </page-header>

  <section class="content">
    <app-filter-form
      [filters]="queryFilters()"
      [filtersForExport]="queryFilters()"
      [entity]="'vouchers'"
      [isExportButtonShown]="true"
      [filterVisible]="filtersExpanded"
      [allFilters]="filters()"
      [defaultFilters]="defaultFilters"
      [advancedFilterKeys]="advancedFilterKeys"
      (onSubmit)="queryVouchers.refetch()"
      (onExportResult)="queryVouchers.refetch()"
      (onClearClick)="clearFilters()"
      (onCreateModalHidden)="exportsModal.showChildModal()"
      [loading]="false"
      [totalItems]="totalItems()"
    >
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4">
          <form-row-input
            [model]="filters().name"
            (modelChange)="setFilters('name', $event)"
            [icon]="null"
            [label]="'voucher.name'"
            (keydown.enter)="queryVouchers.refetch()"
            [dataCyAttribute]="'voucher-name-filter'"
          ></form-row-input>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <form-row-input
            [model]="filters().code"
            (modelChange)="setFilters('code', $event)"
            [icon]="null"
            [label]="'voucher.code'"
            (keydown.enter)="queryVouchers.refetch()"
            [dataCyAttribute]="'voucher-code-filter'"
          ></form-row-input>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <form-row-select
            [model]="filters().discountType"
            (modelChange)="setFilters('discountType', $event)"
            [options]="discountTypeOptions"
            [icon]="null"
            [label]="'voucher.discountType'"
            [dataCyAttribute]="'voucher-discount-type-filter'"
          ></form-row-select>
        </div>
      </div>
      <div class="custom-dropdown" [ngClass]="{ open: filtersExpanded() }">
        <div class="row">
          <div class="col-12 col-sm-4 col-md-2">
            <form-row-select
              [model]="filters().enabled"
              (modelChange)="setFilters('enabled', $event)"
              [options]="enabledOptions"
              [icon]="null"
              [label]="'enabled'"
              [dataCyAttribute]="'voucher-is-active-filter'"
            ></form-row-select>
          </div>
          <div class="col-12 col-sm-4 col-md-2">
            <form-row-select
              [model]="filters().isValid"
              (modelChange)="setFilters('isValid', $event)"
              [options]="isValidOptions"
              [icon]="null"
              [label]="'voucher.isValid'"
              [dataCyAttribute]="'voucher-is-valid-filter'"
            ></form-row-select>
          </div>
          <div class="col-12 col-sm-4 col-md-2">
            <form-row-select
              [model]="filters().isUsed"
              (modelChange)="setFilters('isUsed', $event)"
              [options]="isUsedOptions"
              [icon]="null"
              [label]="'voucher.isUsed'"
              [dataCyAttribute]="'voucher-is-used-filter'"
            ></form-row-select>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <form-row-input
              [label]="'voucher.validFrom'"
              [icon]="null"
              [inputType]="'date'"
              [model]="filters().validDate.left_date"
              (modelChange)="setFilters('validDate', $event, 'left_date')"
              [dataCyAttribute]="'voucher-valid-from-filter'"
            ></form-row-input>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <form-row-input
              [label]="'voucher.validTo'"
              [icon]="null"
              [inputType]="'date'"
              [model]="filters().validDate.right_date"
              (modelChange)="setFilters('validDate', $event, 'right_date')"
              [dataCyAttribute]="'voucher-valid-to-filter'"
            ></form-row-input>
          </div>
        </div>
      </div>
    </app-filter-form>

    <!--    todo check - binding signal data here as signal or take with '()' - just value and in base-listing work with it just like string ? -->
    <app-base-listing
      [listName]="'vouchers'"
      [query]="queryVouchers"
      [columns]="listingColumns"
      [selectedColumns]="listingColumns"
      [sortProp]="sortProp"
      [sortDir]="sortDir"
    ></app-base-listing>
  </section>
</div>
